import { render, staticRenderFns } from "./Hotels.vue?vue&type=template&id=76270b30&scoped=true"
import script from "./Hotels.vue?vue&type=script&lang=js"
export * from "./Hotels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76270b30",
  null
  
)

export default component.exports